import CoreComponent from '../../../ui/navigation/heroSubPage/heroSubPage.vue';
export default {
  extends: CoreComponent
};